/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Amount } from './Amount';
import {
    AmountFromJSON,
    AmountFromJSONTyped,
    AmountToJSON,
    AmountToJSONTyped,
} from './Amount';

/**
 * An object representing a charge. Information about the charge is provided in both the billable currency and the request currency.
 * @export
 * @interface Charge
 */
export interface Charge {
    /**
     * 
     * @type {Amount}
     * @memberof Charge
     */
    billableCurrency?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Charge
     */
    requestCurrency?: Amount;
}

/**
 * Check if a given object implements the Charge interface.
 */
export function instanceOfCharge(value: object): value is Charge {
    return true;
}

export function ChargeFromJSON(json: any): Charge {
    return ChargeFromJSONTyped(json, false);
}

export function ChargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Charge {
    if (json == null) {
        return json;
    }
    return {
        
        'billableCurrency': json['billable_currency'] == null ? undefined : AmountFromJSON(json['billable_currency']),
        'requestCurrency': json['request_currency'] == null ? undefined : AmountFromJSON(json['request_currency']),
    };
}

export function ChargeToJSON(json: any): Charge {
    return ChargeToJSONTyped(json, false);
}

export function ChargeToJSONTyped(value?: Charge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billable_currency': AmountToJSON(value['billableCurrency']),
        'request_currency': AmountToJSON(value['requestCurrency']),
    };
}

